import { render, staticRenderFns } from "./setupTemplate.vue?vue&type=template&id=f7c75804&scoped=true"
import script from "./setupTemplate.vue?vue&type=script&lang=js"
export * from "./setupTemplate.vue?vue&type=script&lang=js"
import style0 from "./setupTemplate.vue?vue&type=style&index=0&id=f7c75804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c75804",
  null
  
)

export default component.exports